export default __webpack_public_path__ + "static/media/screenShots_jewelry-2.a7724ede.jpg";